<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="700px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="140px">
      <el-form-item label="间室：" prop="type">
        <Select style="width: 240px;" placeholder="间室" v-model="form.type" :options="typeList">
        </Select>
      </el-form-item>
      <el-form-item label="设备型号：" prop="model">
        <el-input v-model.trim="form.model" clearable placeholder="请填写设备型号"></el-input>
      </el-form-item>
      <el-form-item label="层数：" prop="row">
        <el-input-number
          v-model.trim="form.row"
          :min="1"
          :max="20"
          step-strictly
          placeholder="层数"
          controls-position="right"
          @change="wineChange"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="列数：" prop="col">
        <el-input-number
          v-model.trim="form.col"
          :min="1"
          :max="15"
          step-strictly
          placeholder="列数"
          controls-position="right"
          @change="wineChange"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="实际库存容量：" v-if="form.row && form.col">
        <div class="explain">默认全部可放置，单击选择不可放置区</div>
        <div class="wineBox">
          <div class="wineDiv" v-for="n in form.row" :key="'row_' + n">
            <div
              class="wine"
              :class="{ stop: isStop(n, m) }"
              v-for="m in form.col"
              :key="'row_' + m"
              @click="changeState(n, m)"
            ></div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="sign">
          <span class="sign-img"></span>
          <span class="sign-font">可放置</span>
          <span class="sign-img stop"></span>
          <span class="sign-font">不可放置</span>
        </div>
      </el-form-item>
      <el-form-item label="图片：">
        <p>格式图片：PNG、JPG、JPEG</p>
        <Upload :img="form.picture" @pickImg="(file) => pickImg(file)" />
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          v-model.trim="form.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请填写备注"
          resize="none"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
import Upload from '@manage/components/Upload'
import { uploadFile } from '@manage/utils/utils'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object
    }
  },
  components: {
    Select,
    Upload
  },
  data() {
    return {
      dialogVisible: this.visible,
      typeList: [],
      form: {
        id: '',
        devType: '02', // 01厨冷 02红酒
        type: '',
        model: '',
        row: 1,
        col: 1,
        picture: '',
        remark: ''
      },
      stopWine: [],
      rules: {
        type: [
          {
            required: true,
            message: '请选择间室',
            trigger: 'change'
          }
        ],
        model: [
          {
            required: true,
            message: '请填写设备型号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[\u4e00-\u9fa5\x21-\x7E]+$/
              if (!reg.test(value)) {
                callback(new Error('设备型号由中英文字符、数字和特殊符号组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        row: [
          {
            required: true,
            message: '请填写层数',
            trigger: ['blur', 'change']
          }
        ],
        col: [
          {
            required: true,
            message: '请填写列数',
            trigger: ['blur', 'change']
          }
        ]
      },
      addApi: this.$api.basicdata.device_type_add,
      updateApi: this.$api.basicdata.device_type_update
    }
  },
  mounted() {
    this.typeList = [
      {
        code: '0018yquwclzb4otl',
        name: '一室酒柜'
      },
      {
        code: '0028yquwclzb4otl',
        name: '两室酒柜'
      }
    ]
    if (this.row.id) {
      this.queryDetail(this.row.id)
    }
  },
  methods: {
    queryDetail(id) {
      let params = {
        id: id
      }
      this.$ajax.get(this.$api.basicdata.device_type_detail, params).then((res) => {
        this.form = res.data

        // 获取酒柜不可放置
        let stopArr = res.data.arrange.split(',')
        for (let i = 0; i < stopArr.length; i++) {
          let itemArr = stopArr[i].split('')
          for (let j = 0; j < itemArr.length; j++) {
            if (itemArr[j] === '0') {
              let row = i + 1 > 9 ? (i + 1).toString() : '0' + (i + 1).toString()
              let col = j + 1 > 9 ? (j + 1).toString() : '0' + (j + 1).toString()
              this.stopWine.push(row + col)
            }
          }
        }
        console.log(this.stopWine)
      })
    },
    pickImg(file) {
      if (file) {
        uploadFile(file).then((res) => {
          this.form.picture = res.data
        })
      } else {
        this.form.picture = ''
      }
    },
    wineChange() {
      this.stopWine = []
    },
    isStop(row, col) {
      let zRow = row > 9 ? row.toString() : '0' + row.toString()
      let zCol = col > 9 ? col.toString() : '0' + col.toString()
      let target = zRow + zCol
      return this.stopWine.join().indexOf(target) > -1 ? true : false
    },
    changeState(row, col) {
      let zRow = row > 9 ? row.toString() : '0' + row.toString()
      let zCol = col > 9 ? col.toString() : '0' + col.toString()
      let target = zRow + zCol
      console.log(target)
      if (this.stopWine.join().indexOf(target) === -1) {
        this.stopWine.push(target)
      } else {
        this.stopWine.splice(this.stopWine.indexOf(target), 1)
      }
      console.log(this.stopWine)
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            id: this.form.id,
            devType: this.form.devType,
            model: this.form.model,
            type: this.form.type,
            row: this.form.row,
            col: this.form.col,
            picture: this.form.picture,
            remark: this.form.remark
          }

          // 酒柜布局字段，1为可放，0为不可放
          let arrange = ''
          let arr1 = [] // 一维数组
          let arr2 = [] // 二维数组
          for (let i = 0; i < this.form.col; i++) {
            arr2.push(1)
          }
          for (let i = 0; i < this.form.row; i++) {
            arr1.push(JSON.parse(JSON.stringify(arr2)))
          }

          // 排除不可放
          if (this.stopWine.length > 0) {
            for (let i = 0; i < this.stopWine.length; i++) {
              let row = Number(this.stopWine[i].substr(0, 2))
              let col = Number(this.stopWine[i].substr(2, 2))
              arr1[row - 1][col - 1] = 0
            }
          }
          for (let i = 0; i < arr1.length; i++) {
            arrange += arr1[i].join('') + ','
          }
          arrange = arrange.substr(0, arrange.length - 1)

          params.arrange = arrange
          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
  .explain {
    font-size: 14px;
    color: #ec6161;
  }
  .wineBox {
    display: inline-block;
    padding-bottom: 16px;
    width: auto !important;
    border: 3px solid #c0c1c4;
    border-radius: 4px;
    .wineDiv {
      padding: 20px 4px 0 8px;
      width: auto !important;
      border-bottom: 3px solid #c0c1c4;
      .wine {
        float: left;
        margin-right: 4px;
        width: 24px;
        height: 24px;
        border: 3px solid rgba(220, 220, 220, 0.98);
        border-radius: 50%;
        cursor: pointer;
        &.stop {
          background-image: url('../../../assets/invalid.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          border: none;
        }
      }
      .clearfix {
        width: auto !important;
      }
    }
  }
  .sign {
    height: 18px;
    line-height: 18px;
    .sign-img {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      width: 12px;
      height: 12px;
      border: 2px solid #dddddd;
      border-radius: 50%;
      &.stop {
        background-image: url('../../../assets/invalid.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: none;
      }
    }
    .sign-font {
      display: inline-block;
      margin-right: 24px;
      font-size: 12px;
      color: #666666;
    }
  }
}
</style>
